'use client';
import { Box, Grid, GridColumn, Carousel, CarouselSlide, Typography, Flex, omitText } from '@kohler-dsm-library/kohler-core';
import { ArrowRightIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import Autoplay from 'embla-carousel-autoplay';
import React, { useRef, useMemo } from 'react';
import classes from './PromoBanner.module.css.mjs';

const PromoBanner = ({
  content,
  carouselControlProps,
  autoplay = true,
  autoplayDelay = 1e4
}) => {
  const autoplayPluginRef = useRef(autoplay ? Autoplay({ delay: autoplayDelay }) : null);
  const plugins = useMemo(() => autoplayPluginRef.current ? [autoplayPluginRef.current] : void 0, [autoplayPluginRef.current]);
  const handleMouseEnter = () => {
    autoplayPluginRef.current?.stop();
  };
  const handleMouseLeave = () => {
    autoplayPluginRef.current?.play();
  };
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.promoBanner, "kohler-promo-banner-root") }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement(
    Carousel,
    {
      withControls: true,
      includeGapInSize: false,
      slideGap: "20px",
      loop: true,
      plugins,
      onMouseEnter: autoplay ? handleMouseEnter : void 0,
      onMouseLeave: autoplay ? handleMouseLeave : void 0,
      carouselControlProps: { ...carouselControlProps },
      customLeftControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: "var(--content-primary)", "aria-label": "go to previous slide" }, /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" })),
      customRightControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: "var(--content-primary)", "aria-label": "go to next slide" }, /* @__PURE__ */ React.createElement(ArrowRightIcon, { withBoundingBox: false, size: "small" }))
    },
    content.map((message, index) => /* @__PURE__ */ React.createElement(CarouselSlide, { key: index, className: classes.promoBannerSlide }, /* @__PURE__ */ React.createElement(Typography, { size: "label-medium-xs", component: "div" }, message.content), message.CTAs && /* @__PURE__ */ React.createElement(Flex, { gap: 20 }, message.CTAs.map((link) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: "href" in link && link.href ? "a" : "button",
          size: "label-medium-xs",
          textDecoration: "underline",
          textColor: "var(--content-primary)",
          whiteSpace: "nowrap",
          key: link.text,
          ...omitText(link)
        },
        link.text
      )
    )))))
  ))));
};

export { PromoBanner };
